export default "__VITE_ASSET__BtneL3VX__"